import { useCourseReviewCreateOrUpdate } from './useCourseReviewCreateOrUpdate';
import { useCourseReviewListing } from './useCourseReviewListing';
import { useCourseReviewMe } from './useCourseReviewMe';
import { useCourseReviewSummary } from './useCourseReviewSummary';

export const MIN_COURSE_REVIEW = 3;

type UseCourseReviewProps = {
  idName?: string;
};

export const useCourseReview = ({ idName }: UseCourseReviewProps) => {
  const {
    handleFetchCourseReviewList,
    courseReviewListData,
    courseReviewListDataError,
    isCourseReviewListDataLoading,
    isCourseReviewListDataError,
    isCourseReviewListDataSuccess,
    courseReviewListPage,
    handleResetCourseReviewList,
  } = useCourseReviewListing({ idName });

  const {
    handleFetchCourseReviewMe,
    courseReviewMeData,
    courseReviewMeDataError,
    isCourseReviewMeDataLoading,
    isCourseReviewMeDataError,
    isCourseReviewMeDataSuccess,
    handleResetCourseReviewMe,
  } = useCourseReviewMe({ idName });

  const {
    handleFetchCourseReviewSummary,
    courseReviewSummaryData,
    courseReviewSummaryDataError,
    isCourseReviewSummaryDataLoading,
    isCourseReviewSummaryDataError,
    isCourseReviewSummaryDataSuccess,
    averageRatingTotal,
    handleResetCourseReviewSummary,
  } = useCourseReviewSummary({ idName });

  const {
    handleCreateOrUpdateCourseReview,
    createOrUpdateCourseReviewStateData,
    createOrUpdateCourseReviewDataError,
    isCreateOrUpdateCourseReviewDataLoading,
    isCreateOrUpdateCourseReviewDataError,
    isCreateOrUpdateCourseReviewDataSuccess,
  } = useCourseReviewCreateOrUpdate({ idName });

  const handleResetCourseReview = () => {
    handleResetCourseReviewList();
    handleResetCourseReviewMe();
    handleResetCourseReviewSummary();
  };

  return {
    handleFetchCourseReviewList,
    courseReviewListData,
    courseReviewListDataError,
    isCourseReviewListDataLoading,
    isCourseReviewListDataError,
    isCourseReviewListDataSuccess,
    courseReviewListPage,

    handleFetchCourseReviewMe,
    courseReviewMeData,
    courseReviewMeDataError,
    isCourseReviewMeDataLoading,
    isCourseReviewMeDataError,
    isCourseReviewMeDataSuccess,

    handleFetchCourseReviewSummary,
    courseReviewSummaryData,
    courseReviewSummaryDataError,
    isCourseReviewSummaryDataLoading,
    isCourseReviewSummaryDataError,
    isCourseReviewSummaryDataSuccess,
    averageRatingTotal,

    handleCreateOrUpdateCourseReview,
    createOrUpdateCourseReviewStateData,
    createOrUpdateCourseReviewDataError,
    isCreateOrUpdateCourseReviewDataLoading,
    isCreateOrUpdateCourseReviewDataError,
    isCreateOrUpdateCourseReviewDataSuccess,

    handleResetCourseReview,
  };
};
